/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomerImportValidationErrorType {
    MISSING_FIELD = 'MissingField',
}
